import React from 'react';

import type { ISVGElement } from 'components/icons/types';

export const ArrowDownIcon = (props: ISVGElement) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="#68717B" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3536 6.3132C12.5488 6.50846 12.5488 6.82504 12.3536 7.0203L8.35355 11.0203C8.15829 11.2156 7.84171 11.2156 7.64645 11.0203L3.64645 7.0203C3.45118 6.82504 3.45118 6.50846 3.64645 6.31319C3.84171 6.11793 4.15829 6.11793 4.35355 6.31319L8 9.95964L11.6464 6.3132C11.8417 6.11793 12.1583 6.11793 12.3536 6.3132Z"
    />
  </svg>
);
